import { queryOptions, useQuery } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { queryKeys } from '@/api/utils/queryKeys';
import { Modal } from '@/components/ModalRenderer/Modal';
import { PortableTextContent } from '@/components/shared';
import { cmsApi } from '@/integrations/sanity/api';

const BodyContent = styled.div`
  & > * + * {
    margin-top: 8px;
  }
`;

const termsAndConditionsQueryOptions = () =>
  queryOptions({
    queryKey: queryKeys.cms.termsAndConditions,
    queryFn: () => cmsApi.getTermsAndConditions(),
    staleTime: Infinity,
  });

const TermsAndConditionsModal = () => {
  const { t } = useTranslation(['Common']);
  const { data: termsAndConditionsData } = useQuery(termsAndConditionsQueryOptions());

  if (!termsAndConditionsData) {
    return null;
  }

  return (
    <Modal title={t('termsAndConditionsFairloEverydayLoans')}>
      <div className="flex flex-col gap-4">
        {termsAndConditionsData?.contentBlockGroup?.contentBlocks?.map(contentBlock => (
          <div key={contentBlock._key}>
            <div className="flex flex-col gap-4">
              <h4 className="text-body-semibold">{contentBlock.title}</h4>
              <BodyContent>
                {!!contentBlock.body && <PortableTextContent value={contentBlock.body} />}
              </BodyContent>
            </div>
          </div>
        ))}
      </div>
    </Modal>
  );
};

export default TermsAndConditionsModal;
